<template>
  <BaseModal :show.sync="show" :hide-footer="true" :hide-header="true">
    <div class="text-modal-header">
      <strong>Details</strong>
      <button type="button" aria-label="Close" class="close button__close-modal" @click="close()">
        ×
      </button>
    </div>

    <OrderDetailSummary
      class="detail-container"
      :order="order"
      :payment="payment"
      :hide="{
        id: true,
        date: true
      }"
    />
    <b-col v-if="remainingTime" class="text__timer container-timer">
      <span class="text-timer"><strong>Please complete the transaction by</strong></span
      ><span class="time-timer">{{ remainingTime }}</span>
    </b-col>
    <b-col>
      <hr />
    </b-col>

    <b-col v-if="!isExpired" class="qr-container">
      <div class="qr-header"><b>Scan QR Code</b></div>
      <div class="qr-image">
        <b-img center :src="payment.qr_code" alt="QR Code" :heigth="240" :width="240"></b-img>
      </div>
      <div class="account-name">
        <strong>Account Name:</strong>
        <br />
        King Mongkut's University of Technology Thonburi
      </div>
      <div class="qr-payment-info">
        <div>
          After the payment is completed, verification will take 3–5 minutes. You can then access
          the MC via the 'User Dashboard' menu.
        </div>
        <div>(This page can be closed after payment.)</div>
      </div>
      <div class="save-button d-flex justify-content-center align-items-center">
        <b-button block variant="success" @click="saveImage">Save QR Code</b-button>
      </div>
    </b-col>

    <b-col v-else class="exprired-qr-container">
      <div class="qr-header">
        <b>The QR code for your payment has expired</b>

        <div class="qr-sub-header">Please initiate a new payment.</div>
      </div>

      <div class="save-button d-flex justify-content-center align-items-center">
        <b-button variant="outline-primary" @click="close">Close</b-button>
      </div>
    </b-col>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal.vue';
import OrderDetailSummary from '@/components/Payment/OrderDetailSummary.vue';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import Order from '@/models/Order';
import Payment from '@/models/Payment';
export default {
  components: {
    BaseModal,
    OrderDetailSummary
  },
  mixins: [datetimeMixin],
  props: {
    order: {
      type: Order,
      required: true
    },
    payment: {
      type: Payment,
      default: null
    }
  },
  data() {
    return {
      remainingTime: '',
      isExpired: false,
      show: false,
      timeCounter: null
    };
  },
  watch: {
    payment(newv, old) {
      if (newv.id !== old.id) {
        if (this.timeCounter) {
          clearInterval(this.timeCounter);
        }
        this.startCountdown();
      }
    }
  },

  mounted() {
    this.startCountdown();
  },

  beforeDestroy() {
    if (this.timeCounter) {
      clearInterval(this.timeCounter);
    }
  },

  methods: {
    startCountdown() {
      this.isExpired = false;

      if (!this.payment || !this.payment.due_date || this.payment.status === 'SUCCESS') return;

      this.updateRemainingTime();

      if (this.timeCounter) clearInterval(this.timeCounter);

      this.timeCounter = setInterval(this.updateRemainingTime, 1000);
    },

    updateRemainingTime() {
      let dueDate = this.$_datetimeMixin_convertUTC(new Date(this.payment.due_date));
      let now = this.$_datetimeMixin_convertUTC(new Date());

      let distance = dueDate - now;

      if (distance < 0) {
        this.isExpired = true;

        if (this.timeCounter) {
          clearInterval(this.timeCounter);
        }
      } else {
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        hours = hours.toString().padStart(2, '0');
        minutes = minutes.toString().padStart(2, '0');
        seconds = seconds.toString().padStart(2, '0');

        this.remainingTime = hours + ':' + minutes + ':' + seconds;
      }
    },

    close() {
      if (this.timeCounter) {
        clearInterval(this.timeCounter);
      }

      this.show = false;

      this.$emit('close');
    },
    open() {
      this.show = true;
      this.$emit('open');
    },
    saveImage() {
      let img = document.querySelector('.qr-image img'); // Select the image you want to save
      let url = img.src; // Get the image's URL

      // Create a new anchor element and trigger a download
      let a = document.createElement('a');
      a.href = url;
      a.download = 'qr_code.jpg';
      a.click();
    }
  }
};
</script>

<style lang="scss" scoped>
.text-modal-header {
  font-size: 19px;
  padding-bottom: 1rem;
}
.close-button {
  float: right;
}
.detail-container {
  background-color: #f4f5fd;
}
.container-timer {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-top: 10px;
}
.time-timer {
  font-size: 18px;
  opacity: 0.7;
}
.qr-header {
  // margin-bottom: 1rem;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.exprired-qr-container .qr-header {
  margin-bottom: 1.5rem;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  padding: 2rem 2rem;
  gap: 16px;
}
.qr-sub-header {
  font-size: 16px;
  opacity: 0.7;
  line-height: 22px;
  margin-top: 1rem;
  text-align: center;
}
.account-name {
  font-size: 16px;
  text-align: center;
  margin-bottom: 1.5rem;
}

.qr-payment-info {
  font-size: 14px;
  text-align: center;
  margin-bottom: 1.5rem;
}
.save-button {
  width: 100%;

  button {
    width: 60%;
  }
}
</style>
